import { render } from "./Folio.vue?vue&type=template&id=ce27c640"
import script from "./Folio.vue?vue&type=script&lang=js"
export * from "./Folio.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/lakshitha1629.github.io/lakshitha1629.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__